module.exports = __webpack_public_path__ + "img/G3.695ef936.png";